import { useEffect, useState } from 'react';

import { SearchTextInputProps } from './search-text-input.component';

interface ViewProps {
    valid: boolean;
    touched: boolean;
    changeTouched: React.Dispatch<React.SetStateAction<boolean>>;
    isValid: () => boolean;
    filterValue: string | null;
    setFilterValue: React.Dispatch<React.SetStateAction<string | null>>;
}

const useSearchTextInput = (props: SearchTextInputProps): ViewProps => {
    const [touched, changeTouched] = useState<boolean>(false);
    const [valid, changeValid] = useState<boolean>(false);
    const [filterValue, setFilterValue] = useState<string | null>(props.value ?? null);

    useEffect(() => {
        if (props.resetInput) {
            setFilterValue('');
        }
    }, [props.resetInput]);

    useEffect(() => {
        setFilterValue(props.value ?? null);
    }, [props.value]);

    useEffect(() => {
        if (filterValue === null) return;
        const timeOutId = setTimeout(() => onChange(filterValue), 300);
        return () => clearTimeout(timeOutId);
    }, [filterValue]);

    const onChange = async (value: string) => {
        props.onChange && props.onChange(value);
    };

    const isValid = (): boolean => {
        let check = true;
        if (check === true && props.required === true && (props.value === '' || props.value === undefined)) check = false;
        if (props.valid !== undefined && check === true) check = props.valid;
        changeValid(check);
        return check;
    };

    useEffect(() => {
        if (props.isValidCallback) {
            props.isValidCallback(isValid());
        } else isValid();
    }, [props.value, props.valid]);

    useEffect(() => {
        if (props.submitted) {
            !touched && changeTouched(true);
        }
    }, [props.submitted]);
    return {
        valid,
        touched,
        isValid,
        changeTouched,
        filterValue,
        setFilterValue
    };
};

export default useSearchTextInput;
